import axios from 'axios';
import { User } from '../interfaces/api/user';

export interface UserFilterParams {
	fields?: string;
}

function queryBuilderUser(params: UserFilterParams): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.fields) {
		queryParams.append('fields', params.fields);
	}
	return queryParams;
}

export async function getUsers(params: UserFilterParams = {}): Promise<User[]> {
	try {
		const queryParams = queryBuilderUser(params);
		const response = await axios.get<User[]>('api/users/', {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getUser(params: UserFilterParams = {}): Promise<User> {
	try {
		const queryParams = queryBuilderUser(params);
		const response = await axios.get<User>('api/users/current/', {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getUserPermissions(): Promise<string[]> {
	try {
		const response = await axios.get<string[]>('api/users/user_permissions');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
